import React from "react";
import { Link } from "react-router-dom";

const ProductInfo = ({ productInfo }) => {
  return (
    <div className="flex flex-col gap-5">
      <h2 className="text-4xl font-semibold">{productInfo.productName}</h2>
      {/* <div className="flex items-center gap-3">
        <p className="text-lg text-gray-500 line-through">
          ₹{productInfo.ogprice}
        </p>
        <p className="text-xl font-semibold text-primeColor">
          ₹{productInfo.price}
        </p>
      </div> */}

      <p className="text-base text-gray-600">{productInfo.des}</p>
      <p className="font-medium text-lg">
        <span className="font-normal">Quantity:</span> {productInfo.color}
      </p>
      <Link to='/contact'>
        <button
          className="w-full py-4 bg-primeColor hover:bg-black duration-300 text-white text-lg font-titleFont"
        >
          Send an Enquiry
        </button>
      </Link>

    </div>
  );
};

export default ProductInfo;
